import { createSlice, current } from '@reduxjs/toolkit';
import { setLanguage as setLanguageDict } from '../tools/Dictionary';

export const languageSlice = createSlice({
  name: 'language',
  initialState: {
    Current: {
      code: "EN",
      name: "English"
    },
    Languages: []
  },
  reducers: {
    setLanguages: (state, action) =>
    {
      state.Languages = action.payload;

    },
    setLanguage: (state, action) =>
    {
      let currentLanguage = current(state).Languages.find(n => n.code == action.payload);

      if (!currentLanguage) return state;

      setLanguageDict(currentLanguage.code, currentLanguage.name);
      state.Current = current(state).Languages.find(n => n.code == action.payload);

    }
  }
});

export const { setLanguages, setLanguage } = languageSlice.actions;

export const getLanguages = state => state.language.Languages

export const getLanguage = state => state.language.Current;

export const getLanguageCode = state => state.language.Current.code;


export default languageSlice.reducer;
